import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { RateCardDetailPage } from "@/features/rate-cards/pages/rate-card-detail-page";
import { rateCardDetailFilterSchema } from "@/features/rate-cards/schemas/rate-card-filter.schema";

export const Route = createFileRoute(
	"/_authenticated/admin/rate-cards/$rateCardId"
)({
	head: () => pageTitle("Rate Card"),
	component: RateCardDetailPage,
	validateSearch: zodValidator(rateCardDetailFilterSchema),
});
